import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { PermissionSelector } from '@grid-ui/permissions';
import { selectWhoAmI, selectWhoAmIUserName } from '@grid-ui/whoami';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
  TopUserMenuAccountSettingsAction,
  TopUserMenuActionsUnion,
  TopUserMenuApiTokenAction,
  TopUserMenuLogoutAction,
  TopUserMenuSubscriptionsAction,
} from '../../models';

@Component({
  selector: 'mc-top-user-menu',
  templateUrl: './top-user-menu.component.html',
  styleUrls: ['./top-user-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TopUserMenuComponent {
  private readonly store = inject(Store);
  public readonly username$ = this.store.select(selectWhoAmIUserName);
  public readonly isAccountAdmin$ = this.store.select(selectWhoAmI).pipe(map((w) => !!w?.is_account_admin));
  public readonly showApiTokenMenuItem$ = this.store.select(selectWhoAmI).pipe(map((w) => !!w?.is_account_admin || !!w?.is_token_creator));

  @Input() isHome = false;

  @Output() menuActionEmit = new EventEmitter<TopUserMenuActionsUnion>();

  public readonly PermissionSelector = PermissionSelector;

  public clickAccountSettings(): void {
    this.menuActionEmit.emit(new TopUserMenuAccountSettingsAction());
  }

  public clickSubscriptions(): void {
    this.menuActionEmit.emit(new TopUserMenuSubscriptionsAction());
  }

  public clickApiToken(): void {
    this.menuActionEmit.emit(new TopUserMenuApiTokenAction());
  }

  public clickLogout(): void {
    this.menuActionEmit.emit(new TopUserMenuLogoutAction());
  }
}
